import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Hero } from "@/components/Hero";
import { ProblemSection } from "@/components/ProblemSection";
import { VisionSection } from "@/components/VisionSection";
import { HowItWorks } from "@/components/HowItWorks";
import { HubTypologies } from "@/components/HubTypologies";
import { NetworkSection } from "@/components/NetworkSection";
import { SiteFooter } from "@/components/SiteFooter";
import { DemoModal } from "@/components/DemoModal";
import { DemoModalProvider } from "@/context/DemoModalContext";

const Home = () => {
  return (
    <div className="App">
      <Hero />
      <ProblemSection />
      <VisionSection />
      <HowItWorks />
      <HubTypologies />
      <NetworkSection />
      <SiteFooter />
      <DemoModal />
    </div>
  );
};

function App() {
  return (
    <DemoModalProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </DemoModalProvider>
  );
}

export default App;
